var React = require('react');

function Padlock (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM2.6,5.2l0-0.5c0-2.2,1.8-4,4-4h3.1c2.2,0,4,1.8,4,4.1l0,0.4","key":0}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinejoin":"round","strokeMiterlimit":"10","points":"14.8,15.3 \n\t\t1.1,15.2 1.1,5.6 14.9,5.6 \t","key":1}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"9.6","r":"1.3","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"8","y1":"10.9","x2":"8","y2":"12.9","key":3})]));
}

Padlock.displayName = "Padlock";

Padlock.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Padlock;

Padlock.default = Padlock;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/padlock.svg
// module id = ../icon/src/icons/padlock.svg
// module chunks = 0